/* BAYT Studio Theme JS */

document.addEventListener('DOMContentLoaded', function() {

  /* ── Cart Drawer ── */
  const drawer      = document.getElementById('cart-drawer');
  const overlay     = document.getElementById('cart-drawer-overlay');
  const drawerClose = document.getElementById('cart-drawer-close');
  const drawerBody  = document.getElementById('cart-drawer-body');
  const drawerFooter= document.getElementById('cart-drawer-footer');
  const drawerTotal = document.getElementById('cart-drawer-subtotal');

  function openCart() {
    fetchCart();
    drawer && drawer.classList.add('open');
    overlay && overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer && drawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  drawerClose && drawerClose.addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-cart-open]').forEach(function(el) {
    el.addEventListener('click', function(e) { e.preventDefault(); openCart(); });
  });

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderDrawer(cart); })
      .catch(function() {});
  }

  function renderDrawer(cart) {
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<p style="color:var(--taupe);font-size:13px;text-align:center;padding:40px 0;">Your bag is empty.</p>';
      drawerFooter && (drawerFooter.style.display = 'none');
    } else {
      var html = '';
      cart.items.forEach(function(item) {
        var img = item.image ? '<img class="drawer-item__image" src="' + item.image + '" alt="' + item.title + '">' : '<div class="drawer-item__image"></div>';
        html += '<div class="drawer-item">' + img +
          '<div class="drawer-item__info">' +
          '<p class="drawer-item__title">' + item.product_title + '</p>' +
          (item.variant_title ? '<p class="drawer-item__variant">' + item.variant_title + '</p>' : '') +
          '<p class="drawer-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '</div></div>';
      });
      drawerBody.innerHTML = html;
      if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
      drawerFooter && (drawerFooter.style.display = 'block');
    }
    updateCartCount(cart.item_count);
  }

  function formatMoney(cents) {
    return 'AED ' + (cents / 100).toFixed(2);
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ── Add to Cart ── */
  document.querySelectorAll('[data-add-to-cart]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (btn) { btn.textContent = 'Added!'; }
          fetchCart();
          setTimeout(function() { openCart(); }, 300);
          setTimeout(function() { if (btn) { btn.textContent = orig; btn.disabled = false; } }, 1200);
        })
        .catch(function() {
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        });
    });
  });

  /* ── Quantity Selector ── */
  document.querySelectorAll('.qty-selector').forEach(function(sel) {
    var input = sel.querySelector('.qty-input');
    sel.querySelector('.qty-minus') && sel.querySelector('.qty-minus').addEventListener('click', function() {
      if (input.value > 1) input.value = parseInt(input.value) - 1;
    });
    sel.querySelector('.qty-plus') && sel.querySelector('.qty-plus').addEventListener('click', function() {
      input.value = parseInt(input.value) + 1;
    });
  });

  /* ── Variant Selector ── */
  var selectedOptions = {};

  // Initialise with first active button per option group
  document.querySelectorAll('.variant-btns').forEach(function(wrap) {
    var first = wrap.querySelector('.variant-btn.active') || wrap.querySelector('.variant-btn');
    if (first) selectedOptions[wrap.dataset.option] = first.dataset.value;
  });

  function findVariant() {
    if (!window.productData) return null;
    return window.productData.variants.find(function(v) {
      return Object.keys(selectedOptions).every(function(opt) {
        return v['option' + opt] === selectedOptions[opt];
      });
    });
  }

  function updateVariant() {
    var variant = findVariant();
    if (!variant) return;

    // Update hidden variant ID
    var idInput = document.getElementById('variant-id');
    if (idInput) idInput.value = variant.id;

    // Update main image if this variant has one
    var imgUrl = window.productData.images[variant.id];
    if (imgUrl) {
      var main = document.querySelector('#main-product-image');
      if (main) {
        main.src = imgUrl;
        // Also highlight matching thumbnail
        document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
          t.classList.toggle('active', t.dataset.src === imgUrl);
        });
      }
    }

    // Update add to bag button availability
    var addBtn = document.querySelector('.product-form__add');
    if (addBtn) {
      addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      addBtn.disabled = !variant.available;
    }
  }

  document.querySelectorAll('.variant-btns').forEach(function(wrap) {
    wrap.querySelectorAll('.variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        wrap.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedOptions[wrap.dataset.option] = btn.dataset.value;
        updateVariant();
      });
    });
  });

  /* ── Product Gallery ── */
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.dataset.src;
      var main = document.querySelector('.product-gallery__main img');
      if (main && src) main.src = src;
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ── Mobile Menu ── */
  var mobileNav    = document.getElementById('mobile-nav');
  var menuOpen     = document.getElementById('mobile-menu-open');
  var menuClose    = document.getElementById('mobile-menu-close');

  menuOpen && menuOpen.addEventListener('click', function() {
    mobileNav && mobileNav.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  menuClose && menuClose.addEventListener('click', function() {
    mobileNav && mobileNav.classList.remove('open');
    document.body.style.overflow = '';
  });

  /* ── Cart remove ── */
  document.addEventListener('click', function(e) {
    if (e.target && e.target.matches('[data-cart-remove]')) {
      var key = e.target.dataset.cartRemove;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function() { location.reload(); });
    }
  });

  /* ── Init cart count ── */
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); });

});
